export default (state = {}, {userId, res}: any) => {
  return {
    ...state,
    CSBPlusBanner: {
      [userId]: res,
    },
  };
};
